import './basic-input-search.sass';
import BasicInput from '../../basic-input/src/basic-input';
import axios from 'axios';

export default {
	props: {
		value: {
			required: false
		},
		title: {
			required: true
		},
		formName: {
			type: String,
			default: ''
		},
		isDealersList: {
			required: false,
			default: false,
			type: Boolean
		},
		searchAllUser: {
			type: Boolean,
			default: false,
		},
		userType: {
			required: false,
			default: () => [0],
			type: Array
		},
		searchUserPoint: {
			type: String,
			default: 'searchUser'
		},
		isDisabled: {
			required: false,
			default: false,
			type: Boolean
		},
		needValidation: {
			type: Boolean,
			default: false
		},
		showMagnifier: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	data() {
		return {
			timer: false,
			inputData: '',
			suggestions: [],
			isEmpty: false,
			focused: false,
			loading: false,
			hasError: !this.isDisabled,
			manualError: '',
			userId: ''
		};
	},

	template: `
		<div class="autocomplete" :class="{focused, 'active-autocomplete': !!suggestions.length}">
			<BasicInput
				v-model="inputData"
				:showMagnifier="showMagnifier"
				:disabled="isDisabled"
				:manualError="manualError"
				:title="title"
				:search-input="!!suggestions.length"
				@focus="focused = true"
				@blur="changeFocus()"
				@input="search(false)"
			/>
			<ul
				v-if="suggestions.length > 0 && !isEmpty && !isDisabled"
				class="autocomplete__dropdown"
			>
				<li
					class="autocomplete__item"
					v-for="(item, index) in suggestions"
					:key="index"
					@click="chooseOption(item)"
				>
					<span class="autocomplete__item-text">{{ item.SEARCH_STRING }}</span>
				</li>
			</ul>
			<ul
				v-if="isEmpty"
				class="autocomplete__dropdown"
			>
				<li
					class="autocomplete__item"
				>
					<span class="autocomplete__item-text">Ничего не найдено</span>
				</li>
			</ul>
		</div>
	`,

	methods: {
		search(isForcing) {
			this.loading = true;
			this.$emit('triggered-input');
			this.isEmpty = false;
			if(this.timer || this.inputData.length < 3) {
				this.suggestions = [];
				if(this.inputData.length < 1) {
					this.$emit('change', {});
				}
				this.timer = false;
				return;
			}
			this.timer = setTimeout(() => {
				let requestData;
				
				if (this.inputData.length < 3) {
					return;
				}
				
				const isTeceSearch = this.inputData.toLowerCase() === 'tec' || this.inputData.toLowerCase() === 'tece';

				if (this.isDealersList && !isTeceSearch) {
					requestData = {
						app: 'searchDiller',
						data: {
							query: this.inputData
						}
					};
				} else if (this.searchAllUser) {
					requestData = {
						app: 'searchAllUser',
						data: {
							user_status: [17],
							request: this.inputData,
						},
					}
				} else {
					requestData = {
						app: this.searchUserPoint,
						data: {
							type_user: this.userType,
							request: this.inputData
						}
					};
				};

				axios.post('/rest/', requestData)
					.then((response) => {
						if(isForcing) {
							response.data.result.data[0].SEARCH_STRING ? this.inputData = response.data.result.data[0].SEARCH_STRING : response.data.result.data[0].NAME;
							this.$emit('change', response.data.result.data[0]);
						} else {
							this.suggestions = response.data.result.data;
							if(this.isDealersList) {
								this.suggestions.forEach(item => item.SEARCH_STRING = item.NAME);
							}
						}

						this.isEmpty = response.data.result.data[0].result;
					})
					.catch(() => {
						this.isEmpty = true;
					})
					.finally(() => {
						this.timer = false;
						this.loading = false;
					});
			}, 500);
		},

		chooseOption(item) {
			this.inputData = item.SEARCH_STRING;
			this.suggestions = [];
			this.userId = item.ID;
			this.hasError = false;
			this.$emit('change', item);
		},

		checkIfTarget(e) {
			if(!e.target.closest('.autocomplete')) {
				this.suggestions = [];
			}
		},

		changeFocus() {
			this.focused = false;
			if (!this.userId && this.needValidation) {
				this.hasError = true;
				this.manualError = 'Необходимо выбрать пользователя';
			}
		}
	},

	created() {
		if(this.value) {
			this.inputData = this.value;
			this.search(true);
		}
	},

	watch: {
		inputData: {
			deep: true,
			handler(value) {
				if (this.manualError) {
					this.manualError = '';
					this.hasError = false;
				}
				if (!value.length && this.needValidation) {
					this.userId = '';
					this.hasError = true;
					this.$emit('change', {ID: ''});
				}
			}
		}
	},

	mounted() {
		this.hasError = this.needValidation ? !this.$attrs.value : false;

		document.addEventListener('click', this.checkIfTarget);
	},

	beforeDestroy() {
		document.removeEventListener('click', this.checkIfTarget);
	},

	components: {
		BasicInput: BasicInput
	}
};
